module.exports = __webpack_public_path__ + "static/media/ระบบกลาง_[FAQ] สำหรับหน่วยงาน_06.afb6c916.pdf";